import React, { memo, useEffect } from "react";
import { compose } from "redux";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import get from "lodash/get";
import validate from "validations";
import { forms, paths } from "utils/constants";
import SmartRender from "containers/SmartRender";
import {
  makeSelectPageValidations,
  makeSelectCisPartnersForm,
  makeSelectCisPartnersFormParams,
  makeSelectPartnerFormFields,
  makeSelectCisPartner
} from "ducks/selectors";
import { uploadCisPartnersForm, getCisPartnersField } from "ducks/actions";
import { gotoUrl, pathWithChannel } from "utils/helpers";
import Spinner, { styles } from "components/Spinner";

const CisRequestPartners = Component =>
  function Comp(props) {
    const { getCisFormFields, uploadCisPartnersData, payload, match } = props;
    const { partnerID } = get(match, "params");

    useEffect(() => {
      if (partnerID) {
        getCisFormFields({ name: partnerID });
      }
    }, [getCisFormFields, partnerID]);
    if (!payload.campaignId) {
      return <Spinner size={200} sx={styles.fullPage} />;
    }

    const onSubmit = () => {
      uploadCisPartnersData(payload, (result, errors) => {
        if (!errors) {
          gotoUrl(pathWithChannel(paths.CIS_PARTNERS_SUCCESS));
        }
      });
    };

    return <Component {...props} onSubmit={onSubmit} />;
  };

const mapStateToProps = createStructuredSelector({
  formValidations: makeSelectPageValidations(forms.CIS_PARTNERS_FORM),
  formValues: makeSelectCisPartnersForm(),
  formFields: makeSelectPartnerFormFields(),
  cisPartner: makeSelectCisPartner(),
  payload: makeSelectCisPartnersFormParams()
});

const mapDispatchToProps = dispatch => {
  return {
    getCisFormFields: payload => dispatch(getCisPartnersField(payload)),
    uploadCisPartnersData: (payload, callback) =>
      dispatch(uploadCisPartnersForm(payload, callback))
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.CIS_PARTNERS_FORM,
    destroyOnUnmount: false,
    validate
  }),
  memo
)(CisRequestPartners(SmartRender));
